module.exports = __webpack_public_path__ + "media/images/chart-50b35b8fd415437d82efc7e64e2c98b2.svg";